import { UPDATE_PRESTADOR } from '../actions'

export default function (state = {}, action) {
  switch (action.type) {
    case UPDATE_PRESTADOR:
      return action.payload.data
    default:
      return state
  }
}
